var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyperlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12h5M14 7h1a5 5 0 0 1 5 5v0a5 5 0 0 1-5 5h-1M10 7H9a5 5 0 0 0-5 5v0a5 5 0 0 0 5 5h1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlink);
export default __webpack_public_path__ + "static/media/hyperlink.c7efc4fd4e4753c5a617aedb342b6861.svg";
export { ForwardRef as ReactComponent };